import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../Styling/SeafaresEmployeeDetailsNavi1.css";

const cards = [
  {
    title: "New Hire",
    description:
      "Start onboarding, document collection, and pre-joining checks.",
    icon: "📁",
    ribbonClass: "pink",
    cardClass: "card-newhire",
    path: "/new-hire",
  },
  {
    title: "Onroll / Employee Lists",
    description:
      "Start onboarding, document collection, and pre-joining checks.",
    icon: "👥",
    ribbonClass: "green",
    cardClass: "card-onroll",
    path:"/EmployeeList"
  },
  {
    title: "Leads",
    description:
      "Start onboarding, document collection, and pre-joining checks.",
    icon: "📋",
    ribbonClass: "orange",
    cardClass: "card-leads",
    path:"/navi1LeadManagement"
  },
];

export default function DashboardCards() {
  const navigate = useNavigate();
  return (
    <div className="seafaresemployeeDetail-container">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`card ${card.cardClass}`}
          onClick={() => navigate(card.path)}
        >
          <div className={`corner top-right ${card.ribbonClass}`} />
          <div className={`corner bottom-left ${card.ribbonClass}`} />

          <div className="card-content">
            <div className="icon">{card.icon}</div>

            <h3>{card.title}</h3>

            <p>{card.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
